import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { OrderStatus } from '../../../shared/enums';
import { Guid, Nillable } from '@web/utils';
import { OrderNumber } from '../../../shared/types/order-number';
import { PublicOrderBillingAddressResponse } from './public-order-billing-address.response';
import { PublicOrderItemResponse } from './public-order-item.response';
import { PublicOrderPaymentResponse } from './public-order-payment.response';
import { PublicOrderShipmentResponse } from './public-order-shipment.response';
import { PublicOrderInvoiceResponse } from './public-order-invoice.response';
import { PublicOrderContextOperationsResponse } from './public-order-context-operations.response';
import { RefundSummaryResponse } from '../../../shared/api/responses';
import { OrderRefundCollectionItemResponse } from '../../../shared/api/responses/order-refund-collection-item.response';

@jsonObject
export class PublicOrderDetailsResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly number!: OrderNumber;

  @jsonMember(String)
  public readonly status!: OrderStatus;

  @jsonMember(Number)
  public readonly totalPrice!: number;

  @jsonMember(RefundSummaryResponse)
  public readonly refundSummary?: Nillable<RefundSummaryResponse>;

  @jsonMember(Number)
  public readonly totalItems!: number;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(PublicOrderBillingAddressResponse)
  public readonly billingAddress!: PublicOrderBillingAddressResponse;

  @jsonMember(String)
  public readonly comment?: Nillable<string>;

  @jsonArrayMember(PublicOrderItemResponse)
  public readonly items!: PublicOrderItemResponse[];

  @jsonArrayMember(PublicOrderPaymentResponse)
  public readonly payments!: PublicOrderPaymentResponse[];

  @jsonMember(PublicOrderInvoiceResponse)
  public readonly invoice?: Nillable<PublicOrderInvoiceResponse>;

  @jsonMember(PublicOrderInvoiceResponse)
  public readonly temporaryInvoice?: Nillable<PublicOrderInvoiceResponse>;

  @jsonArrayMember(PublicOrderShipmentResponse)
  public readonly shipments?: Nillable<PublicOrderShipmentResponse[]>;

  @jsonMember(PublicOrderContextOperationsResponse)
  public readonly contextOperations!: PublicOrderContextOperationsResponse;

  @jsonArrayMember(OrderRefundCollectionItemResponse)
  public readonly refunds!: OrderRefundCollectionItemResponse[];
}
